class CosumyDeliveryDate {
  constructor() {
    this.init();
  }

  init() {
    // Wait a bit for DOM to be ready
    setTimeout(() => {
      this.updateDeliveryDisplay();
    }, 100);
    
    // Update on cart changes
    document.addEventListener('cart:updated', () => {
      setTimeout(() => this.updateDeliveryDisplay(), 100);
    });
  }

  calculateDeliveryRange() {
    const now = new Date();
    const currentHour = now.getHours();
    const currentDay = now.getDay(); // 0 = Sunday, 1 = Monday, etc.
    
    // Determine shipping start date based on current time and day
    let shippingStartDate = new Date(now);
    
    // Special logic: If Friday after 14:00, Saturday, or Sunday -> ship Monday
    if ((currentDay === 5 && currentHour >= 14) || currentDay === 6 || currentDay === 0) {
      // Find next Monday
      while (shippingStartDate.getDay() !== 1) {
        shippingStartDate.setDate(shippingStartDate.getDate() + 1);
      }
    } else if (this.isWeekend(now) || currentHour >= 14) {
      // Other cases: ship next business day
      shippingStartDate = this.getNextBusinessDay(now);
    } else {
      // Before 2 PM on weekday - can ship same day
      shippingStartDate = new Date(now);
    }
    
    // Shipping range: start date and next business day
    const shippingEndDate = this.getNextBusinessDay(shippingStartDate);
    
    return {
      start: shippingStartDate,
      end: shippingEndDate
    };
  }

  getNextBusinessDay(date) {
    const nextDay = new Date(date);
    nextDay.setDate(nextDay.getDate() + 1);
    
    while (this.isWeekend(nextDay)) {
      nextDay.setDate(nextDay.getDate() + 1);
    }
    
    return nextDay;
  }

  addBusinessDays(date, days) {
    const result = new Date(date);
    let addedDays = 0;
    
    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      if (!this.isWeekend(result)) {
        addedDays++;
      }
    }
    
    return result;
  }

  isWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6; // Sunday or Saturday
  }

  formatDate(date) {
    const days = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
    const dayName = days[date.getDay()];
    const day = date.getDate();
    const month = date.getMonth() + 1;
    
    return `${dayName}. ${day}.${month}.`;
  }

  updateDeliveryDisplay() {
    const deliverySpan = document.querySelector('.cosumy-delivery-date');
    if (!deliverySpan) {
      console.log('Cosumy Delivery: Element not found');
      return;
    }

    const now = new Date();
    const currentHour = now.getHours();
    const range = this.calculateDeliveryRange();
    const startFormatted = this.formatDate(range.start);
    const endFormatted = this.formatDate(range.end);
    
    const deliveryText = `Versand von ${startFormatted} bis ${endFormatted}`;
    deliverySpan.textContent = deliveryText;
    
    console.log(`Cosumy Delivery updated (${currentHour}:00 Uhr):`, deliveryText);
    console.log('Start date:', range.start);
    console.log('End date:', range.end);
  }
}

// Initialize delivery date calculator
function initCosumyDeliveryDate() {
  if (!window.cosumyDeliveryDate) {
    window.cosumyDeliveryDate = new CosumyDeliveryDate();
    console.log('Cosumy Delivery Date initialized');
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCosumyDeliveryDate);
} else {
  // DOM already loaded
  initCosumyDeliveryDate();
}

// Also initialize on cart updates
document.addEventListener('cart:updated', initCosumyDeliveryDate);